module.exports = __webpack_public_path__ + "static/media/starterguide4v2.79ef341e.png";